import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { URLS, APPLICATION_GLOBAL_SLUG, createMarkup, stripHtml, APPLICATION_NAME, replaceNbsp } from "src/_config";
import { useCmsApi } from "src/_common/hooks/actions/cms/cmsApiHook";
import { toast } from "react-toastify";
import Sponsor from "../common/Sponsor";

export default function CmsPage() {
  const cmsApi = useCmsApi();
  const [content, setContent] = useState<any>();
  const { slug } = useParams<any>();
  const history = useHistory();

  const goBack = () => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push(URLS.HOME);
    }
  };

  const getCmsContentDetails = () => {
    var params = {
      game_slug: APPLICATION_GLOBAL_SLUG,
      slug,
    };

    cmsApi.callGetCmsContent(
      params,
      (message: string, resp: any) => {
        if (resp && resp.list) {
          setContent(resp.list);
        } else {
          setContent("");
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  useEffect(() => {
    if (content) {
      const prevTitle = document.title;
      document.title = `${APPLICATION_NAME} : ${content.title}`;
      return () => {
        document.title = prevTitle;
      };
    }
  }, [content]);

  useEffect(() => {
    getCmsContentDetails();
  }, []);

  return (
    <React.Fragment>
      <h2 className="page-title text-left">
        <a onClick={goBack} className="back-history">
          <img src="/images/left-white.svg" alt="back" />
        </a>
        {/* <span>About </span>Us */}
        {content?.title || <span>Back</span>}
        <hr className="color-white" />
      </h2>
      <hr className="color-white" />
      <div className="form-box-new">
        <div className="row">
          <p
            className="normal-text"
            dangerouslySetInnerHTML={createMarkup(
              content && content.long_description ? replaceNbsp(content.long_description) : "No content added!"
            )}
          />
        </div>
      </div>
      <Sponsor />
    </React.Fragment>
  );
}
